import { SdkContext } from '../internal'
import type { StorefrontConfig, StorefrontListing, StorefrontMode } from '@/types/storefront'

/** A leftover `{ data }` envelope or the native payload: read either. */
const unwrap = <T>(response: unknown): T => {
  const value = response as { data?: unknown } | null
  return (value && typeof value === 'object' && 'data' in value && value.data && typeof value.data === 'object'
    ? value.data
    : value) as T
}

/** The storefront space module (F-29): what a store shows and what it sells. */
export class StorefrontResource {
  constructor(private ctx: SdkContext) {}

  /** What this viewer may buy here, in three groups (F-29 phase 3): one-offs, plans and add-ons with their availability. */
  async listProducts(spaceId: string): Promise<StorefrontListing> {
    return unwrap<StorefrontListing>(await this.ctx.call(
      { httpMethod: 'GET', path: '/storefront/spaces/{spaceId}/products' },
      { spaceId }
    ))
  }

  /** Owner or admin: the mode, the picked products and plans, in display order. */
  async getConfig(spaceId: string): Promise<StorefrontConfig> {
    return unwrap<StorefrontConfig>(await this.ctx.call(
      { httpMethod: 'GET', path: '/storefront/spaces/{spaceId}' },
      { spaceId }
    ))
  }

  async updateConfig(spaceId: string, config: { mode: StorefrontMode; productIds: string[]; planIds?: string[] }): Promise<StorefrontConfig> {
    return unwrap<StorefrontConfig>(await this.ctx.call(
      { httpMethod: 'PUT', path: '/storefront/spaces/{spaceId}', hasBody: true },
      { spaceId, body: config }
    ))
  }
}
